import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerDividerColor } from '../../palette';

const theme = createTheme();

export const DividerComponent: Components = {
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: String(ControllerDividerColor.Border),
        margin: theme.spacing(0.5, 0),
      },
      light: {
        borderColor: String(ControllerDividerColor.BorderLight),
      },
    },
  },
};
